import { DESIGN } from 'types/design';
import { ButtonStyled as defaultBtn } from './style';
import { ButtonStyled as deBtn } from './styleDE';

export const buttons = {
  [DESIGN.default]: defaultBtn,
  [DESIGN.DE]: deBtn,
};
